import { ActionType } from "../actions/actionTypes";

type PaymentState = {
  loading: boolean;
  plans: dTOARPayPlanDto[];
  error?: string;
};

const INITIAL_STATE = {
  loading: false,
  plans: [] as dTOARPayPlanDto[]
};

export default (state = INITIAL_STATE, action: ActionType): PaymentState => {
  switch (action.type) {
    case "PAYMENT_PLANS_REQUEST": {
      return { ...state, loading: true };
    }
    case "PAYMENT_PLANS_FAILURE": {
      return { ...state, error: action.payload, loading: false };
    }
    case "PAYMENT_PLANS_SUCCESS": {
      return { ...state, error: undefined, ...action.payload, loading: false };
    }
    default:
      return state;
  }
};
